export const prefixes = {
  'arxiv': 'https://arxiv.org/abs/',
  'doi': 'https://doi.org/',
}
let anyPattern = Object.values(prefixes).join('|')
anyPattern = `^(${anyPattern})`

export const anyPrefixPattern = new RegExp(anyPattern, 'mi')
